<template>
	<div>
		<div class="section container">
			<div class="alert alert-danger" v-if="!checkAkses">
				<p>
					<strong
						>Akun Anda belum terverifikasi oleh petugas BAPENDA
						Ketapang.</strong
					>
				</p>
			</div>
			<div class="row">
				<div class="col-sm-3">
					<component :is="'a'" @click="goBack()">
						<card
							class="border-0 d-flex card-sipp"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object type="image" class="text-white card-pajak">
								<i class="fa fa-backward mr-2" style="font-size: 100px"></i>
							</object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								HAWALAMAN AWAL
							</h6>
						</card>
					</component>
				</div>
				<div class="col-sm-3">
					<component :is="'a'" @click="goRegistration()">
						<card
							class="border-0 d-flex card-registration2"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object
								data="/img/svg/15-registration.svg"
								type="image/svg+xml"
								class="text-white card-pajak"
							></object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								{{ registration_label }}
							</h6>
						</card>
					</component>
				</div>
				<div class="col-md-3">
					<component :is="'a'" @click="login()" v-if="!isLogin">
						<card
							class="border-0 d-flex card-hotel"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object type="image" class="text-white card-pajak">
								<i class="fa fa-sign-in mr-2" style="font-size: 100px"></i>
							</object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								LOGIN
							</h6>
						</card>
					</component>
					<component :is="'a'" @click="logout()" v-else>
						<card
							class="border-0 d-flex card-hotel"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object type="image" class="text-white card-pajak">
								<i class="fa fa-sign-out mr-2" style="font-size: 100px"></i>
							</object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								LOGOUT
							</h6>
						</card>
					</component>
				</div>
				<div class="col-md-3" v-if="checkAkses">
					<component :is="'a'" @click="goForm()">
						<card
							class="border-0 d-flex card-bphtb"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object
								data="/img/svg/10-BPHTB.svg"
								type="image/svg+xml"
								class="text-white card-pajak"
							></object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								INPUT BPHTB
							</h6>
						</card>
					</component>
				</div>
				<div class="col-md-3" v-if="checkAkses">
					<component :is="'a'" @click="goPengurangan()">
						<card
							class="border-0 d-flex card-bphtb"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object
								data="/img/svg/10-BPHTB.svg"
								type="image/svg+xml"
								class="text-white card-pajak"
							></object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								INPUT PENGURANGAN
							</h6>
						</card>
					</component>
				</div>
				<div class="col-md-3" v-if="isLogin">
					<component :is="'a'" @click="goTracking()">
						<card
							class="border-0 d-flex card-sipp"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object
								data="/img/svg/9-SIPP.svg"
								type="image/svg+xml"
								class="text-white card-pajak"
							></object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								TRACKING BPHTB
							</h6>
						</card>
					</component>
				</div>

				<div class="col-md-3" v-if="checkAkses">
					<component :is="'a'" @click="goHistories()">
						<card
							class="border-0 d-flex card-hiburan"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object type="image" class="text-white card-pajak">
								<i class="fa fa-history mr-2" style="font-size: 100px"></i>
							</object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								HISTORI TRANSAKSI
							</h6>
						</card>
					</component>
				</div>

				<div class="col-md-3" v-if="checkAkses">
					<component :is="'a'" @click="goDaftar()">
						<card
							class="border-0 d-flex card-database"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object
								data="/img/svg/14-DB.svg"
								type="image/svg+xml"
								class="text-white card-pajak"
							></object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								LIST PENDAFTARAN
							</h6>
						</card>
					</component>
				</div>

				<div class="col-md-3" v-if="checkAkses">
					<component :is="'a'" @click="goPelaporan()">
						<card
							class="border-0 d-flex card-hotel"
							hover
							shadow
							body-classes="text-center align-items-center d-flex justify-content-center"
						>
							<object
								data="/img/svg/10-BPHTB.svg"
								type="image/svg+xml"
								class="text-white card-pajak"
							></object>
							<h6
								class="text-white text-uppercase title-inside-card"
								style="margin-top: 7px"
							>
								PELAPORAN PAJAK
							</h6>
						</card>
					</component>
				</div>
			</div>
		</div>
		<registration
			ref="modal-registration"
			title="Registrasi User"
		></registration>
		<login-user ref="modal-login"></login-user>
		<modal-tracking ref="modal-tracking"></modal-tracking>
		<modal-histories ref="modal-histories"></modal-histories></div
></template>
<script>
import Registration from "./Regstration.vue"
import LoginUser from "./LoginUser"
import ModalTracking from "./Tracking"
import ModalHistories from "./Histories"
export default {
	name: "home",
	components: { Registration, LoginUser, ModalTracking, ModalHistories },
	computed: {
		isLogin() {
			return this.$store.state.auth.status.loggedIn
		},
		checkAkses() {
			if (this.$store.state.auth.status.loggedIn)
				if (this.$store.state.auth.user.is_ppat)
					return this.$store.state.auth.user.ppat != null
			return false
		},
		registration_label() {
			return this.$store.state.auth.status.loggedIn
				? this.$store.state.auth.user.name
				: "REGISTRASI"
		},
	},
	methods: {
		goRegistration() {
			this.$refs["modal-registration"].showModal()
			if (this.isLogin) {
				this.$refs["modal-registration"].updateMode(this.$store.state.auth.user)
			}
		},
		goDaftar() {
			this.$router.push("/bphtb/daftar")
		},
		goForm() {
			this.$router.push("/bphtb/from-daftar")
		},
		goPengurangan() {
			this.$router.push("/bphtb/pengurangan")
		},
		goPelaporan() {
			this.$router.push("/bphtb/pelaporan-pajak")
		},
		goTracking() {
			this.$refs["modal-tracking"].showModal()
		},
		goHistories() {
			this.$refs["modal-histories"].showModal()
		},
		login() {
			this.$refs["modal-login"].showModal()
		},
		async logout() {
			await this.$store.dispatch("auth/logout")

			this.$router.push("/landing")
		},
		goBack() {
			this.$router.push("/landing")
		},
	},
}
</script>
